var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2802 16.2802C15.987 16.5733 15.5126 16.5733 15.2195 16.2802L9 10.0607L2.78052 16.2802C2.48736 16.5733 2.01299 16.5733 1.71983 16.2802C1.42672 15.987 1.42672 15.5127 1.71983 15.2195L7.93936 9.00001L1.71983 2.78054C1.42672 2.48738 1.42672 2.013 1.71983 1.71985C2.01299 1.42674 2.48736 1.42674 2.78052 1.71985L9 7.93937L15.2195 1.71985C15.5126 1.42674 15.987 1.42674 16.2802 1.71985C16.5733 2.013 16.5733 2.48738 16.2802 2.78054L10.0606 9.00001L16.2802 15.2195C16.5733 15.5127 16.5733 15.987 16.2802 16.2802Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7264_4383",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2802 16.2802C15.987 16.5733 15.5126 16.5733 15.2195 16.2802L9 10.0607L2.78052 16.2802C2.48736 16.5733 2.01299 16.5733 1.71983 16.2802C1.42672 15.987 1.42672 15.5127 1.71983 15.2195L7.93936 9.00001L1.71983 2.78054C1.42672 2.48738 1.42672 2.013 1.71983 1.71985C2.01299 1.42674 2.48736 1.42674 2.78052 1.71985L9 7.93937L15.2195 1.71985C15.5126 1.42674 15.987 1.42674 16.2802 1.71985C16.5733 2.013 16.5733 2.48738 16.2802 2.78054L10.0606 9.00001L16.2802 15.2195C16.5733 15.5127 16.5733 15.987 16.2802 16.2802Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7264_4383)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f23b76e467e6997e23e6848489b031f2.svg";
export { ForwardRef as ReactComponent };